/**********************************************************************************
               _                      _
              (_)  ___    ___  _ _   (_) _ __   _ _
              | |/' _ '\/',__)( '_'\ | |( '__)/'_' )
              | || ( ) |\__, \| (_) )| || |  ( (_| |
              (_)(_) (_)(____/|  __/ (_)(_)   \__,_)
                              | |
                              (_)

                           Cris - Nov 2014

*************************************************************************************/

$(document).ready(function(){

  //console.log('We will miss you Dan, loads!!');

  // buy art collection page
  var initializedMain = false;
  function masonryMe(){
    if($(window).width() > 724){
      if(initializedMain == true){
         $('.masonry').masonry('destroy');
      }
      var halfWidth = parseInt($('.masonry').width()/2)-1;
      $('.masonry').masonry({
        columnWidth: halfWidth,
        itemSelector: '.product'
      });
      initializedMain = true;
    } else{
      if(initializedMain == true){
        $('.masonry').masonry('destroy');
      }
      initializedMain = false;
    }
   }

  var initialized = false;
  function masonryMeMobile(){

    if($(window).width() < 724){
      if(initialized == true){
        $('.masonry-mobile').masonry('destroy');
      }
      var halfWidth = parseInt($('.masonry-mobile').width()/2)-1;
      var mobMasonry = new $('.masonry-mobile').masonry({
        columnWidth: halfWidth,
        itemSelector: '.product'
      });
      initialized = true;
    }else{
      if(initialized == true){
        $('.masonry-mobile').masonry('destroy');
      }
      initialized = false;

    }
  }

  function relocateFilters(){
    if($('#relocate-me').length){
      if($(window).width() < 724){
        $('.desktop-filters-wrap #relocate-me').remove();
      } else if($(window).width() > 723){
        $('.mobile-filtering-box #relocate-me').remove();
      }
    }
  }

  relocateFilters();

  function fadeMeIn(){
    $('.fadeMeIn').each(function(){
      $(this).fadeTo('fast',1);
    });
  }

  fadeMeIn();

  $(window).load(function(){
    masonryMe();
    masonryMeMobile();
  });

  $(window).resize(function(){
      masonryMe();
      masonryMeMobile();
  });

  // initialize filtering
  if($('#collection-filter').length) {
     filters.init();
  }

  $('#toggle-filters,#filters-close').click(function(){
    $('.mobile-filtering-box').toggle();
    $('.counting-items').toggle();
    $('#toggle-filters').toggle();
  });

  // filtering trigger
  $('.filters-buy-art .trigger').click(function(e){
    e.preventDefault();
    $(this).toggleClass('trigger').toggleClass('activetrigger');
    $(this).next().find('ul').toggleClass('dropdownhidden').toggleClass('dropdownvisible');
  });

  // basket icon redirects
  $('.basket a').click(function(){
    if($(this).attr('href') != '#'){
      window.location.href = $(this).attr('href');
    }
  });

  if($('#raw-description').length > 0 && $('#raw-description .has-metira').length <= 0){

  }

  // buy art product page description
  if($('#raw-description').length > 0 && $('#raw-description .has-metira').length <= 0){
    $('#desc-work,#desc-artist,#desc-exhib,#desc-specs').each(function(i){
      $(this).addClass('accordion-content');
      var prependedTitle = $(this).find('h2').html();
      $(this).before('<div class="dinamic-arrow"></div><h2 class="accordion-trigger">'+prependedTitle+'</h2>');
      $(this).find('h2').remove();
    });
  }

  if($('.image.featured.portrait').length && $('#desc-specs-portrait').length <= 0){
    var elToMove = $('#desc-specs').text();
    //$('#desc-specs').remove();
    $('#show-options').before('<div id="desc-specs-portrait"></div>');
    //$('#desc-specs-portrait').text(elToMove);
  }

  //clean page
  if($('#raw-description').length > 0 && $('#raw-description .has-metira').length <= 0){
    $('#raw-description br').each(function(){
      if($(this).parent().hasClass('description')){
        $(this).remove();
      }
    });

    $('#raw-description p').each(function(){
      if($(this).text() == ''){
        $(this).remove();
      }
    });
  }

  if($('#raw-description').length > 0 && $('#raw-description .has-metira').length <= 0){
    if($('#raw-description #desc-specs').length > 0){
      if(!$('#raw-description #desc-specs p').length){
        $('#raw-description #desc-specs').wrapInner('<p></p>');
      }
    }
  }

  if($('#desc-specs').length && $('#not-available').length == 0){
    var priceDesc = $('.purchase.mobile').html();
    // $('#desc-specs').append(priceDesc);
    // $('#desc-specs #price-preview-top').removeAttr('id');
  }

  if($('#desc-specs-portrait').length && $('#not-available').length == 0){
    var priceDesc = $('.purchase.mobile').html();
    $('#desc-specs-portrait').append(priceDesc);
    $('#desc-specs-portrait #price-preview-top').removeAttr('id');
  }

  $('#raw-description').on('click', '.accordion-trigger', function () {
     $(this).prev().toggle();
     $(this).toggleClass('accordion-open');
     $(this).next('.accordion-content').slideToggle();
  });


  // Buy art Enquire form submit
  $('#not-available .form-submit-button').click(function(e){
    e.preventDefault();
    //$('#not-available .jotform-form').submit();
    var formdata = $('#not-available .jotform-form').serialize();
    $.post('http://submit.jotformeu.com/submit/43413295524352/', formdata);
    e.preventDefault();
    $('#not-available form').hide();
    $('#not-available .thanks-enquiry').fadeIn();
  });

  $('#not-available-mobile .form-submit-button').click(function(e){
    e.preventDefault();
    //$('#not-available-mobile .jotform-form').submit();
    var formdata = $('#not-available-mobile .jotform-form').serialize();
    $.post('http://submit.jotformeu.com/submit/43413295524352/', formdata);
    e.preventDefault();
    $('#not-available-mobile form').hide();
    $('#not-available-mobile .thanks-enquiry').fadeIn();
  });

  $('.contactEditions .form-submit-button').click(function(e){
    e.preventDefault();
    //$('.contactEditions .jotform-form').submit();
    var formdata = $('.contactEditions .jotform-form').serialize();
    $.post('http://submit.jotformeu.com/submit/62633967120355/', formdata);
    e.preventDefault();
    $('.contactEditions form').hide();
    $('.contactEditions .thanks-enquiry').fadeIn();
  });


  //buy art show options
  $('#show-options').click(function(e){
    e.preventDefault();
    if($('#product-options').hasClass('single-option')){
      $('#add-to-cart').click();
    }else{
      var elLeft = $(this).position().left - 380;
      var elTop = $(this).position().top + 20;
      $('#product-options').css({'left':elLeft,'top':elTop}).fadeIn();
      $(this).hide();
    }
  });

  $('#close-options').click(function(){
    $('#product-options').fadeOut();
    $('#show-options').fadeIn();
  });

  $('#show-options-mobile').click(function(e){
    e.preventDefault();
    if($('#product-options-mobile').hasClass('single-option')){
      $('#add-to-cart-mobile').click();
    }else{
      $('#product-options-mobile').fadeIn();
      $(this).hide();
    }
  });

  $('#close-options-mobile').click(function(){
    $('#product-options-mobile').fadeOut();
    $('#show-options-mobile').fadeIn();
  });

  // buy art select options
  $('#product-select-simulator li,#product-select-simulator-mobile li').click(function(){
    if($(this).attr('data-selected') == 'not-selected'){
      $(this).parent().find('li[data-selected="selected"]').attr('data-selected','not-selected');
      $(this).attr('data-selected','selected');
      $('#product-select option:selected').removeAttr("selected");
      var otherThis = $(this);
      $('#product-select option').each(function(){
        if($(this).val() == $(otherThis).attr('data-value')){
          $(this).attr('selected','selected');
        }
      });
    }
  });

  // share page
  $(".addthis_sharing_toolbox").prepend("<a href='' class='closeSocial shareOptionsToggle'>-</a>");
  $(".shareOptionsToggle").click(function(){return $(this).parent().parent().find(".addthis_sharing_toolbox").fadeToggle(),$(this).parent().parent().find(".shareOptions").fadeToggle(),!1})


  //product page image zoom
  $('.icon-maximise').click(function(){
    console.log($(this).parent().next().find('a.zoom'));
    $('a.zoom').eq(0).trigger('click');
  });

  // cart trigger dropdown
  $('#donations .trigger').click(function(e){
    e.preventDefault();
    $(this).toggleClass('trigger').toggleClass('activetrigger');
    $(this).next().find('ul').toggleClass('dropdownhidden').toggleClass('dropdownvisible');
    $('#custom-donation-amount-holder').hide();
  });

  // add donation to cart page
  function addMyDonationToPage(item){
    var newPrice = item.line_price/100;

    if($('#updates_'+item.id).length){

      $('#updates_'+item.id).val(item.quantity);
      $('#updates_'+item.id).parent().next().text('£ '+newPrice.toFixed(2));

    }else{
      var count = 1;
      $('td.remove').each(function(){
        count += parseInt($(this).attr('data-line'));
      });
      $('tr.last-cart-line').prev().addClass('dotted-light');
      $('.last-cart-line').before('<tr><td class="image"><div class="product_image"><a href="'+item.url+'"><img src="'+item.image+'"  alt="'+item.title+'" style="width:100px;" /></a></div></td>\
              <td class="item"><a href="'+item.url+'"><img class="mobile_cart_image" src="'+item.image+'" alt="'+item.title+'" style="width:100px;" />'+item.title+'</a>\
              <span class="gift-aid">Gift Aid it?</span><input type="checkbox" name="attributes[gift-aid]" /></td>\
              <td class="qty"><input type="text" size="4" name="updates[]" id="updates_'+item.id+'" value="'+item.quantity+'" onfocus="this.select();" class="tc item-quantity" /></td>\
              <td class="price">£ '+newPrice.toFixed(2)+'</td><td data-line="1" class="remove"><a href="/cart/change?line='+count+'&quantity=0" class="cart"></a></td></tr>');
      $('#cartform').show();
      $('.pageTitle').text('Your cart');
    }

    var newTotal = parseInt($('.summary .price').attr('data-total'))/100 + newPrice;
    $('.summary .total strong').text('£ '+newTotal.toFixed(2));
    var cartCountMe = parseInt($('#cart-count').text()) + 1;
    $('.cart-count').each(function(){
       $(this).text(cartCountMe);
    });

    $('#donations a').removeClass('activetrigger').addClass('trigger');
    $('#donations-options').removeClass('dropdownvisible').addClass('dropdownhidden');
  }

  // add donation to cart
  function addMyDonation(id, quantity) {
      var data = '?id='+id+'&quantity='+(quantity?quantity:1);

      $.ajax({
        type: 'POST',
        url: '/cart/add.js'+data,
        dataType: 'json',
        success: addMyDonationToPage,
        error: Shopify.onError
      });
   }

  // action add donation
  $('#donations-options li').click(function(){
    if($(this).attr('id')==='custom-donation') {
      $('#custom-donation-amount-holder').show(200);
      $('#donations > a').toggleClass('trigger').toggleClass('activetrigger');
      $('#donations > a').next().find('ul').toggleClass('dropdownhidden').toggleClass('dropdownvisible');
    } else {
      var id = $(this).attr('data-id');
      addMyDonation(id);
    }
  });

  $('#custom-donation-amount-submit').click(function(e) {
    e.preventDefault();

    var quantity = $('#custom-donation-amount').val();
    var id = $('#custom-donation').attr('data-id');

    if($.isNumeric(quantity) && +quantity>0 && !~String(quantity).indexOf('.')) {
    	addMyDonation(id, quantity);
      	$('#custom-donation-amount-holder').hide();
    } else {
    	alert('Please provide a positive numeric whole number in the donation amount field.');
    }
  });

  // cart terms and conditions pop up
  $('#buy-art-terms').fancybox({
      padding: '60px',
      maxWidth: '600px',
      minWidth: '60%',
      maxHeight: '600px',
      minHeight: '80%',
      afterClose: function(){
        $('#buy-art-terms-wrap #buy-art-terms').show();
      }
  });

   $('.cart-buy-art-note strong').click(function(){
      $("#buy-art-terms").eq(0).trigger('click');
   });

});
